// web/BuscarEntrega.jsx
// Simple delivery lookup page at /#/buscar
// Built-in numeric keypad (no device keyboard) → redirects to /#/entrega/:id

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Delete, Search } from "lucide-react";
import { brand } from "./shared/brand";

const KEYS = [
  "1", "2", "3",
  "4", "5", "6",
  "7", "8", "9",
  "⌫", "0", "→",
];

export default function BuscarEntrega() {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  function handleKey(key) {
    if (key === "⌫") {
      setValue(v => v.slice(0, -1));
      return;
    }
    if (key === "→") {
      handleSearch();
      return;
    }
    if (value.length >= 8) return; // reasonable max length
    setValue(v => v + key);
  }

  function handleSearch() {
    const trimmed = value.trim();
    if (!trimmed) return;
    navigate(`/entrega/${trimmed}`);
  }

  const canSearch = value.length > 0;

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ background: "#fafafa" }}
    >
      {/* Logo / header */}
      <div className="mb-8 text-center">
        <p
          className="text-3xl font-extrabold italic tracking-tight"
          style={{ color: brand.primary, fontFamily: "Montserrat, sans-serif" }}
        >
          FAST MAX
        </p>
        <p className="text-sm text-slate-500 mt-1 font-medium">
          Rastrea tu entrega
        </p>
      </div>

      {/* Display */}
      <div
        className="w-full max-w-xs rounded-2xl border-2 bg-white mb-6 px-5 py-4 flex items-center justify-between"
        style={{ borderColor: canSearch ? brand.primary : "#e2e8f0" }}
      >
        <span
          className="text-3xl font-mono font-extrabold tracking-widest transition-colors"
          style={{ color: canSearch ? brand.primary : "#cbd5e1", letterSpacing: "0.15em" }}
        >
          {value || "· · · · ·"}
        </span>
        {canSearch && (
          <button
            onClick={() => setValue("")}
            className="ml-3 grid size-8 place-items-center rounded-full bg-slate-100 text-slate-400 hover:bg-slate-200 transition-colors"
          >
            <Delete className="size-4" />
          </button>
        )}
      </div>

      {/* Numeric keypad */}
      <div className="grid grid-cols-3 gap-3 w-full max-w-xs mb-6">
        {KEYS.map(key => {
          const isAction  = key === "→";
          const isDelete  = key === "⌫";

          return (
            <button
              key={key}
              onClick={() => handleKey(key)}
              disabled={isAction && !canSearch}
              className="relative h-16 rounded-2xl text-xl font-bold transition-all active:scale-95 select-none"
              style={{
                background: isAction
                  ? canSearch ? brand.primary : "#e2e8f0"
                  : isDelete
                  ? "#f1f5f9"
                  : "white",
                color: isAction
                  ? canSearch ? "white" : "#94a3b8"
                  : isDelete
                  ? "#64748b"
                  : "#1e293b",
                boxShadow: isAction || isDelete
                  ? "none"
                  : "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)",
                border: isAction || isDelete ? "none" : "1px solid #f1f5f9",
              }}
            >
              {isAction  ? <Search className="size-5 mx-auto" /> : key}
            </button>
          );
        })}
      </div>

      {/* Search button below pad */}
      <button
        onClick={handleSearch}
        disabled={!canSearch}
        className="w-full max-w-xs rounded-2xl py-4 text-base font-extrabold text-white transition-all active:scale-95 disabled:opacity-40"
        style={{ background: brand.primary }}
      >
        Buscar entrega
      </button>

      <p className="mt-4 text-xs text-slate-400 text-center max-w-xs">
        Ingresa el número de entrega que recibiste por WhatsApp
      </p>
    </div>
  );
}